// Keep the stored role identifier stable for existing memberships and audit records.
export const roleLabel = (role) => role === "deputy" ? "Steward" : role;
